import React from 'react';
import Navbar from '../../components/layout/Navbar';
import Footer from '../../components/layout/Footer';
import PageHeader from '../../components/common/PageHeader';

const LearnAbout: React.FC = () => {
  return (
    <>
      <Navbar />
      <main className="min-h-screen pt-16">
        <PageHeader 
          title="About the Program"
          subtitle="Chamber-endorsed AI adoption program for New Zealand SMEs"
        />
        <div className="py-12 bg-white">
          <div className="container mx-auto px-4 sm:px-6 lg:px-8 max-w-4xl">
            <h2 className="text-2xl font-bold mb-6 text-brand-navy">Provider Partnership</h2>
            <p className="text-gray-700 mb-8">
              This program is delivered by <strong>Think Tomorrow AI Limited</strong> in partnership 
              with the <strong>Marlborough Chamber of Commerce</strong>. Together, we're helping New Zealand 
              small businesses adopt AI safely and effectively.
            </p>

            <h2 className="text-2xl font-bold mb-6 text-brand-navy">About Think Tomorrow AI</h2>
            <p className="text-gray-700 mb-8">
              Think Tomorrow AI is a Marlborough-based AI consultancy specializing in practical, 
              privacy-safe AI adoption for small and medium enterprises. We focus on vendor-agnostic 
              solutions that work with the tools you already use.
            </p>

            <h2 className="text-2xl font-bold mb-6 text-brand-navy">About the Chamber Partnership</h2>
            <p className="text-gray-700 mb-8">
              The Marlborough Chamber of Commerce has endorsed this program as meeting their standards 
              for business education and practical value. The certificate you earn is recognized across 
              the Chamber network and maps to published competencies for SME AI adoption.
            </p>

            <h2 className="text-2xl font-bold mb-6 text-brand-navy">Contact Us</h2>
            <p className="text-gray-700">
              Questions about the program? Email us at{' '}
              <a href="mailto:connect@thinktomorrow.ai" className="text-brand-teal hover:underline">
                connect@thinktomorrow.ai
              </a>
            </p>
          </div>
        </div>
      </main>
      <Footer />
    </>
  );
};

export default LearnAbout;
